<template>
	<div class="flex_1 margin_horizontal">
		<AccessRestrictedTabs class="table_tabs"
							  v-model="activeTab"
							  :elements="tabTypes"
							  :session-key="$route.path"
		/>
		<div v-if="activeTab === tabTypes.upload" class="flex ">
			<card-list class="flex_1" @uploaded="updateCounts"></card-list>
		</div>
		<!--    new, waiting, rejected-->
		<UpLoadTable v-if="activeTab === tabTypes.new || activeTab === tabTypes.waiting || activeTab === tabTypes.rejected" :tabInfo="activeTab"></UpLoadTable>
		<SellTable v-if="activeTab === tabTypes.approvedReceivables" @changed="updateCounts"/>
		<SellCurrentTable v-if="activeTab === tabTypes.sellingReceivables" @changed="updateCounts"/>
	</div>
</template>
<script>
import {mapGetters} from "vuex";

import CardList from "@/components/templates/seller/CardList.vue";
import UpLoadTable from "@/components/templates/seller/UpLoadTable.vue";

import {receivableApi} from "@/common/api/receivableApi";
import AccessRestrictedTabs from "@/components/templates/common/permissions/AccessRestrictedTabs";
import {enumDef} from "@/common/enumDefs";
import {navigationTabs} from "@/common/navigation/navigationTabs";
import {hasAccess} from "@/common/permission/permission";

import ReceivableTableWithFilter from "@/components/templates/seller/receivables/ReceivableTableWithFilter";
import SellCurrentTable from "@/components/templates/seller/sell/SellCurrentTable.vue";
import SellTable from "@/components/templates/seller/sell/SellTable.vue";

export default {
	components: {SellTable, SellCurrentTable, AccessRestrictedTabs, CardList, UpLoadTable, ReceivableTableWithFilter },
	data() {
		let tabTypes = {
			upload: {
				name: navigationTabs.seller.sell.upload,
				translationKey: "seller.upload.Upload",
				permission: enumDef.permissions.SellerSellReceivables,
				count: null,
				showPricing: false
			},
			new: {
				name: navigationTabs.seller.sell.new,
				translationKey: "seller.upload.New",
				permission: enumDef.permissions.SellerSellReceivables,
				count: null,
				dataApi: receivableApi.inspection.listNew,
				showPricing: false
			},
			waiting: {
				name: navigationTabs.seller.sell.waiting,
				translationKey: "seller.upload.WaitingReview",
				permission: enumDef.permissions.SellerSellReceivables,
				count: null,
				dataApi: receivableApi.inspection.listWaiting,
				showPricing: true
			},
			rejected: {
				name: navigationTabs.seller.sell.rejected,
				translationKey: "seller.upload.Rejected",
				permission: enumDef.permissions.SellerSellReceivables,
				count: null,
				dataApi: receivableApi.inspection.listDeclined
			},
			approvedReceivables: {
				name: navigationTabs.seller.sell.approved,
				translationKey: "seller.sell.ApprovedExchange",
				permission: enumDef.permissions.SellerSellReceivables,
				count: null,
				showPricing: true
			},
			sellingReceivables: {
				name: navigationTabs.seller.sell.selling,
				translationKey: "seller.sell.Transaction",
				permission: enumDef.permissions.SellerSellReceivables,
				count: null,
				showPricing: true
			},
		};

		return {
			tabTypes: tabTypes,
			activeTab: null,
		};
	},
	created() {
		this.updateCounts();
	},
	methods: {
		updateCounts() {
			if (hasAccess(this.currentUser, enumDef.permissions.SellerSellReceivables)) {
				receivableApi.inspection.counts()
					.then(counts => {
						this.tabTypes.new.count = counts.newCount;
						this.tabTypes.waiting.count = counts.waitingForReviewCount;
						this.tabTypes.rejected.count = counts.rejectedCount;
						this.tabTypes.approvedReceivables.count = counts.approvedCount;
						this.tabTypes.sellingReceivables.count = counts.sellingCount;
					});
			}
		},
	},
	computed: {
		...mapGetters({ tableData: "upTableData" })
	},
	watch: {
		tableData() {
			this.updateCounts();
		},
		activeTab() {
			this.$store.dispatch("setActionUpLoadTab", this.activeTab.name);
		}
	}
};
</script>